import * as React from "react";
import { reportAppLocation } from "../../components/util/location-change";
export class RevoContent extends React.PureComponent {
    componentWillMount() {
        reportAppLocation({ app: "buy", submenu: "???" });
    }
    render() {
        return React.createElement("div", { style: { height: "150vh" } }, "I bims, ein placeholder");
    }
}
//# sourceMappingURL=revo-content.js.map